import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import { benefits } from "src/utils/dataHomePage";

function BenefitsSection() {
  return (
    <>
      <Typography
        variant="h4"
        textAlign="center"
        sx={{
          pt: { lg: 5, sm: 1 },
          pb: { lg: 5, sm: 1 },
          fontFamily: "Oswald, Arial",
          fontSize: { lg: "38px", xs: "25px" },
          color: `${PureLightThemeCaaS.colors.alpha.orange[100]}`,
        }}
      >
        BENEFITS
      </Typography>

      <Box>
        <Grid sx={{ pb: { lg: 10, xs: 0 } }} container spacing={0} justifyContent="space-evenly" alignItems="flex-start">
          {benefits.map((benefit) => (
            <Grid item xs={10} sm={5} lg={6} pt={2} key={benefit.id} display="flex" flexDirection="column" alignItems="center">
              <Typography
                variant="h3"
                sx={{
                  color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                  textDecoration: "underline",
                  pt: 2,
                  pb: 2,
                  fontSize: { lg: "32px", xs: "20px" },
                  lineHeight: 1.2,
                  textAlign: "center",
                }}
              >
                {benefit.title}
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                  fontFamily: "Roboto, Arial",
                  fontWeight: "bold",
                  fontSize: { lg: "26px", xs: "18px" },
                  textAlign: "center",
                  pb: 2,
                  pt: 5,
                }}
              >
                {benefit.subtitle1}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                  fontFamily: "Roboto, Arial",
                  fontWeight: "bold",
                  fontSize: { lg: "18px", xs: "14px" },
                  textAlign: "center",
                  width: { lg: "500px", xs: "auto" },
                  pb: 1,
                  pt: 1,
                  lineHeight: 1.3,
                }}
              >
                {benefit.textPrimary}
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                  fontFamily: "Roboto, Arial",
                  fontWeight: "bold",
                  fontSize: { lg: "26px", xs: "18px" },
                  textAlign: "center",
                  pb: 2,
                  pt: 5,
                }}
              >
                {benefit.subtitle2}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: `${PureLightThemeCaaS.colors.alpha.white[100]}`,
                  fontFamily: "Roboto, Arial",
                  fontWeight: "bold",
                  fontSize: { lg: "18px", sm: "14px" },
                  textAlign: "center",
                  width: { lg: "500px", xs: "auto" },
                  pb: { lg: 1, xs: 6 },
                  pt: 1,
                  lineHeight: 1.3,
                }}
              >
                {benefit.textSecondary}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
}

export default BenefitsSection;
